import {UI} from "../../../stem-core/src/ui/UIBase.js";

import {Messages} from "../../Messages.js";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {Flow} from "../initializeFlows.js";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {LoadingSpinner} from "../../ui/LoadingSpinner.jsx";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {Link} from "../../../stem-core/src/ui/UIPrimitives.jsx";
import {PaymentMethodStore} from "../../State.js";
import {Controller} from "../Controller.js";
import {ThankYouPanelStyle} from "./ThankYouPanel.jsx";


@registerStyle(ThankYouPanelStyle)
export class PaymentFailedPanel extends UI.Element {
    formatPaymentErrorMessage(message) {
        let formattedMessage = (message || "").toString().trim();

        if (!formattedMessage.length) {
            return formattedMessage;
        }

        if (formattedMessage.slice(-1) !== ".") {
            formattedMessage += ".";
        }

        return formattedMessage;
    }

    render() {
        const {styleSheet} = this;
        return [
            <div testId="donateFailedTitle" className={styleSheet.title}>{Messages.donatePaymentFailed}</div>,
            <div testId="donateFailedMessage" className={styleSheet.text}>
                {[this.formatPaymentErrorMessage(Controller.paymentMethod.getPaymentErrorMessage()), Messages.donateFailedMessage]}
            </div>,
            <MerchantButton className={styleSheet.button} onClick={() => this.options.changeURL(
                PaymentMethodStore.getPrimary() ? DONATE_PAGE_URLS.payWithChosenCard : DONATE_PAGE_URLS.payWithAddedCard, true)}>
                {Messages.editPaymentDetails}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.retryPayment} className={styleSheet.link} onClick={() => {
                          LoadingSpinner.show();
                    Flow.donation.donatePageDonate();
                      }}/>
            </div>,
            <PoweredByBlink/>
        ]
    }
}
